import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import PageMeta from '@/components/feature/PageMeta';
import { Link } from 'react-router-dom';

const aboutPageSchema = {
  "@context": "https://schema.org",
  "@type": "AboutPage",
  "name": "关于51动漫",
  "description": "51动漫官网致力于为广大动漫爱好者提供最新、最全的动漫资源。永久免费，高速流畅。",
  "url": "https://www.51dm.com/about"
};

const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    { "@type": "ListItem", "position": 1, "name": "首页", "item": "https://www.51dm.com/" },
    { "@type": "ListItem", "position": 2, "name": "关于我们" }
  ]
};

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "51动漫真的完全免费吗？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "是的，51动漫承诺永久免费。所有动漫资源和NBA赛事视频均可免费在线观看，无需付费或订阅会员。我们通过广告合作维持运营，为用户提供零门槛的观看体验。"
      }
    },
    {
      "@type": "Question",
      "name": "51动漫支持哪些设备观看？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "51动漫全面支持PC端（Windows/Mac）、移动端（iOS/Android手机和平板）以及智能电视等设备。只需浏览器访问即可，无需下载任何App。我们采用HTML5播放技术，兼容所有主流浏览器。"
      }
    },
    {
      "@type": "Question",
      "name": "动漫资源多久更新一次？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "51动漫的番剧资源通常在日本播出后的2-4小时内更新，确保用户第一时间看到最新内容。NBA赛事视频在比赛结束后30分钟内即可观看回放。更新速度在行业中处于领先水平。"
      }
    },
    {
      "@type": "Question",
      "name": "视频播放画质如何？支持投屏吗？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "51动漫提供多种清晰度选项，最高支持1080P超清画质。播放器支持DLNA和AirPlay投屏功能，可以将内容投射到电视等大屏幕上观看，享受更好的观影体验。"
      }
    },
    {
      "@type": "Question",
      "name": "如何找到51动漫的最新入口？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "建议收藏本站官网地址。如遇到访问问题，可通过搜索引擎搜索'51动漫官网'或'51动漫最新地址'来获取最新入口。关注我们的社交媒体账号也可以获取及时通知。"
      }
    }
  ]
};

export default function AboutPage() {
  return (
    <>
      <PageMeta
        title="关于我们 - 51动漫 | 品牌介绍与联系方式"
        description="51动漫官网品牌介绍：致力于为广大动漫爱好者提供最新、最全的动漫在线播放与下载资源，同步更新NBA赛事视频。永久免费，高速流畅。了解51动漫的品牌故事、用户口碑与联系方式。"
        keywords="51动漫, 51动漫官网, 关于51动漫, 51动漫联系方式, 动漫网站介绍"
        canonicalUrl="https://www.51dm.com/about"
        schemaData={[aboutPageSchema, breadcrumbSchema, faqSchema]}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          {/* Breadcrumb */}
          <div className="pt-20 bg-background-50">
            <div className="max-w-7xl mx-auto px-4 md:px-8 py-4">
              <nav aria-label="面包屑导航" className="flex items-center gap-2 text-xs text-foreground-400">
                <Link to="/" className="hover:text-primary-500 transition-colors">首页</Link>
                <i className="ri-arrow-right-s-line"></i>
                <span className="text-foreground-700 font-medium">关于我们</span>
              </nav>
            </div>
          </div>

          {/* Hero */}
          <section className="bg-background-100 border-y border-background-200/50 py-12 md:py-16">
            <div className="max-w-7xl mx-auto px-4 md:px-8 text-center">
              <span className="inline-block px-4 py-1.5 text-xs font-medium text-primary-700 bg-primary-100/50 rounded-full mb-4">
                关于 51动漫
              </span>
              <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
                动漫爱好者的随身追更站
              </h1>
              <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
                51动漫成立于2018年，致力于为广大动漫爱好者提供最新、最全的动漫在线播放与下载资源。
                从热门新番到经典老片，从日本动漫到国产佳作，这里应有尽有。同步更新NBA赛事视频，
                让动漫迷和体育迷都能在这里找到属于自己的精彩内容。
              </p>
            </div>
          </section>

          {/* Brand story */}
          <section className="py-12 md:py-16">
            <div className="max-w-7xl mx-auto px-4 md:px-8">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
                <div>
                  <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
                    我们的品牌故事
                  </h2>
                  <div className="space-y-4 text-sm text-foreground-600 leading-relaxed">
                    <p>
                      <strong className="text-foreground-900">51动漫</strong>诞生于一群动漫爱好者的共同梦想——让每个人都能
                      <strong className="text-foreground-900">永久免费</strong>地观看高质量的动漫作品。
                    </p>
                    <p>
                      2018年，创始团队发现国内动漫爱好者面临着资源分散、画质参差不齐、广告弹窗层出不穷等问题。
                      于是，一个以用户体验为核心、坚持免费原则的动漫平台应运而生。
                    </p>
                    <p>
                      八年过去，51动漫从一个小众的资源分享站，成长为拥有千万级用户的综合性动漫平台。
                      我们不仅提供日本新番、国产动漫、剧场版等海量资源，还开创性地引入了<strong className="text-foreground-900">NBA赛事视频</strong>板块，
                      满足用户多元化的娱乐需求。
                    </p>
                    <p>
                      截至2026年，51动漫已累计服务超过<strong className="text-primary-500">5000万</strong>用户，
                      收录动漫作品<strong className="text-primary-500">12000+</strong>部，
                      NBA赛事回放<strong className="text-primary-500">15000+</strong>场。
                    </p>
                  </div>
                </div>
                <div className="rounded-2xl overflow-hidden aspect-[4/3] bg-background-200">
                  <img
                    src="https://readdy.ai/api/search-image?query=Anime%20streaming%20platform%20brand%20concept%20illustration%20colorful%20vibrant%20modern%20office%20with%20anime%20posters%20and%20screens%20warm%20lighting%20creative%20atmosphere%20professional%20clean%20aesthetic&width=800&height=600&seq=about-brand-story&orientation=landscape"
                    alt="51动漫品牌故事"
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </section>

          {/* Stats */}
          <section className="py-10 md:py-14 bg-background-100">
            <div className="max-w-7xl mx-auto px-4 md:px-8">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
                {[
                  { label: '累计用户', value: '5000万+', icon: 'ri-user-smile-line' },
                  { label: '动漫作品', value: '12000+', icon: 'ri-film-line' },
                  { label: 'NBA赛事', value: '15000+', icon: 'ri-basketball-line' },
                  { label: '用户评分', value: '4.9 / 5.0', icon: 'ri-star-line' },
                ].map((stat) => (
                  <div
                    key={stat.label}
                    className="text-center p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/60"
                  >
                    <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100/50">
                      <i className={`${stat.icon} text-primary-500 text-lg`}></i>
                    </div>
                    <p className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-1">{stat.value}</p>
                    <p className="text-xs text-foreground-400">{stat.label}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Reputation / Testimonials */}
          <section className="py-12 md:py-16">
            <div className="max-w-7xl mx-auto px-4 md:px-8">
              <div className="text-center mb-10">
                <span className="inline-block px-4 py-1.5 text-xs font-medium text-accent-700 bg-accent-100/50 rounded-full mb-3">
                  用户口碑
                </span>
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
                  他们都在用51动漫
                </h2>
                <p className="text-foreground-500 text-sm">来自真实用户的评价</p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
                {[
                  {
                    name: '小明同学',
                    role: '忠实用户 · 追番3年',
                    content: '从大学开始就用51动漫追番了，真的完全免费！画质高清，更新速度也超快。每次新番开播第一时间就能看到，比别的平台快多了。强烈推荐！',
                  },
                  {
                    name: '篮球少年阿杰',
                    role: 'NBA球迷 · 使用2年',
                    content: '本来是来找NBA回放的，结果发现这里动漫资源也超级全！现在每天打开51动漫已经成了习惯。NBA赛事更新很及时，画质也很棒。',
                  },
                  {
                    name: '樱花飘落',
                    role: '动漫博主 · 资深用户',
                    content: '作为一个看了十几年动漫的老粉，51动漫的资源库真的让我惊喜。冷门番也能找到，而且没有任何广告弹窗。界面简洁好用，看番体验超棒！',
                  },
                  {
                    name: '追剧达人小李',
                    role: '二次元爱好者 · 使用1年',
                    content: '朋友推荐的，一开始半信半疑，用了之后真的爱不释手。资源全、更新快、画质好，关键是完全免费！现在每天刷51动漫已经成了生活的一部分。',
                  },
                  {
                    name: '月光疾风',
                    role: '程序员 · 资深动漫迷',
                    content: '作为一个程序员，我特别在意网站的加载速度和用户体验。51动漫在这两方面都做得非常出色，页面简洁流畅，没有任何卡顿。',
                  },
                  {
                    name: '星空下的猫',
                    role: '学生 · 追番新手',
                    content: '刚开始追番的时候完全不知道看什么好，51动漫的推荐和分类功能帮了我大忙。现在已经成为忠实用户了，推荐给了身边好多朋友！',
                  },
                ].map((t, idx) => (
                  <div
                    key={idx}
                    className="rounded-xl p-5 bg-background-100 border border-background-200/60"
                  >
                    <i className="ri-double-quotes-l text-2xl text-accent-300 block mb-3"></i>
                    <p className="text-sm text-foreground-700 leading-relaxed mb-4">{t.content}</p>
                    <div className="flex items-center gap-1 mb-3">
                      {Array.from({ length: 5 }).map((_, i) => (
                        <i key={i} className="ri-star-fill text-accent-500 text-xs"></i>
                      ))}
                    </div>
                    <div className="pt-3 border-t border-background-200/40">
                      <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                      <p className="text-xs text-foreground-400">{t.role}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* FAQ */}
          <section className="py-12 md:py-16 bg-background-100">
            <div className="max-w-3xl mx-auto px-4 md:px-8">
              <div className="text-center mb-10">
                <span className="inline-block px-4 py-1.5 text-xs font-medium text-secondary-700 bg-secondary-100/50 rounded-full mb-3">
                  常见问题
                </span>
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
                  关于51动漫的常见疑问
                </h2>
              </div>

              <div className="space-y-3">
                {[
                  { q: '51动漫真的完全免费吗？', a: '是的，51动漫承诺永久免费。所有动漫资源和NBA赛事视频均可免费在线观看，无需付费或订阅会员。我们通过广告合作维持运营，为用户提供零门槛的观看体验。' },
                  { q: '51动漫支持哪些设备观看？', a: '51动漫全面支持PC端（Windows/Mac）、移动端（iOS/Android手机和平板）以及智能电视等设备。只需浏览器访问即可，无需下载任何App。我们采用HTML5播放技术，兼容所有主流浏览器。' },
                  { q: '动漫资源多久更新一次？', a: '51动漫的番剧资源通常在日本播出后的2-4小时内更新，确保用户第一时间看到最新内容。NBA赛事视频在比赛结束后30分钟内即可观看回放。更新速度在行业中处于领先水平。' },
                  { q: '视频播放画质如何？支持投屏吗？', a: '51动漫提供多种清晰度选项，最高支持1080P超清画质。播放器支持DLNA和AirPlay投屏功能，可以将内容投射到电视等大屏幕上观看，享受更好的观影体验。' },
                  { q: '如何找到51动漫的最新入口？', a: '建议收藏本站官网地址。如遇到访问问题，可通过搜索引擎搜索"51动漫官网"或"51动漫最新地址"来获取最新入口。关注我们的社交媒体账号也可以获取及时通知。' },
                  { q: '51动漫有App可以下载吗？', a: '51动漫目前主要通过网页端提供服务，无需下载安装即可使用。我们正在开发移动App版本，届时将在官网公布下载链接，敬请期待！' },
                ].map((faq, idx) => (
                  <details
                    key={idx}
                    className="group rounded-xl bg-background-50 border border-background-200/60 overflow-hidden cursor-pointer"
                  >
                    <summary className="flex items-center justify-between p-4 md:p-5 text-sm font-semibold text-foreground-900 list-none">
                      {faq.q}
                      <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform duration-200"></i>
                    </summary>
                    <div className="px-4 md:px-5 pb-4 md:pb-5 text-sm text-foreground-600 leading-relaxed">
                      {faq.a}
                    </div>
                  </details>
                ))}
              </div>
            </div>
          </section>

          {/* Contact */}
          <section className="py-12 md:py-16">
            <div className="max-w-3xl mx-auto px-4 md:px-8">
              <div className="text-center mb-8">
                <span className="inline-block px-4 py-1.5 text-xs font-medium text-primary-700 bg-primary-100/50 rounded-full mb-3">
                  联系我们
                </span>
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
                  期待你的声音
                </h2>
                <p className="text-foreground-500 text-sm">
                  有任何问题、建议或合作意向，欢迎随时联系我们
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
                <div className="text-center p-5 rounded-xl bg-background-100 border border-background-200/60">
                  <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100/50">
                    <i className="ri-mail-line text-primary-500 text-lg"></i>
                  </div>
                  <p className="text-sm font-semibold text-foreground-900 mb-1">电子邮件</p>
                  <p className="text-xs text-foreground-400">support@51dm.com</p>
                </div>
                <div className="text-center p-5 rounded-xl bg-background-100 border border-background-200/60">
                  <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100/50">
                    <i className="ri-wechat-line text-accent-500 text-lg"></i>
                  </div>
                  <p className="text-sm font-semibold text-foreground-900 mb-1">微信公众号</p>
                  <p className="text-xs text-foreground-400">51动漫官方</p>
                </div>
                <div className="text-center p-5 rounded-xl bg-background-100 border border-background-200/60">
                  <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-full bg-secondary-100/50">
                    <i className="ri-weibo-line text-secondary-500 text-lg"></i>
                  </div>
                  <p className="text-sm font-semibold text-foreground-900 mb-1">微博</p>
                  <p className="text-xs text-foreground-400">@51动漫官方微博</p>
                </div>
              </div>

              {/* Contact form */}
              <div className="rounded-2xl bg-background-100 border border-background-200/60 p-5 md:p-8">
                <h3 className="text-lg font-heading font-bold text-foreground-950 mb-5">发送消息</h3>
                <form
                  id="contact-form"
                  data-readdy-form
                  action="https://readdy.ai/api/form/d96a3eltfb6ioa7s1lsg"
                  method="POST"
                  encType="application/x-www-form-urlencoded"
                  className="space-y-4"
                  onSubmit={async (e) => {
                    e.preventDefault();
                    const form = e.currentTarget;
                    const honeypot = (form.querySelector('input[name="website_alt"]') as HTMLInputElement)?.value?.trim();
                    if (honeypot) {
                      const msgEl = document.getElementById('form-msg');
                      if (msgEl) { msgEl.textContent = '消息已发送，我们会尽快回复！'; msgEl.className = 'text-sm text-center mt-4 text-green-600'; }
                      form.reset();
                      return;
                    }
                    const fd = new FormData(form);
                    const url = form.getAttribute('action') || '';
                    try {
                      const res = await fetch(url, { method: 'POST', body: fd });
                      const text = await res.text();
                      let parsed: Record<string, unknown> | null = null;
                      try { parsed = JSON.parse(text); } catch { /* ignore */ }
                      const msgEl = document.getElementById('form-msg');
                      if (res.ok && parsed && (parsed as Record<string, unknown>).code === 'OK') {
                        if (msgEl) { msgEl.textContent = '消息已发送，我们会尽快回复！'; msgEl.className = 'text-sm text-center mt-4 text-green-500'; }
                        form.reset();
                      } else {
                        const serverMsg = (parsed as Record<string, unknown>)?.meta && typeof (parsed as Record<string, unknown>)?.meta === 'object' ? ((parsed as Record<string, unknown>)?.meta as Record<string, string>)?.message || '' : '';
                        if (msgEl) { msgEl.textContent = serverMsg || '发送失败，请稍后重试'; msgEl.className = 'text-sm text-center mt-4 text-red-500'; }
                      }
                    } catch {
                      const msgEl = document.getElementById('form-msg');
                      if (msgEl) { msgEl.textContent = '网络错误，请稍后重试'; msgEl.className = 'text-sm text-center mt-4 text-red-500'; }
                    }
                  }}
                >
                  <input type="hidden" name="form_name" value="Contact Form" />
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                      <label htmlFor="contact-name" className="block text-xs font-medium text-foreground-600 mb-1.5">姓名</label>
                      <input
                        id="contact-name"
                        type="text"
                        name="name"
                        required
                        className="w-full px-3 py-2.5 text-sm rounded-lg bg-background-50 border border-background-300/60 text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400/30"
                        placeholder="请输入您的姓名"
                      />
                    </div>
                    <div>
                      <label htmlFor="contact-email" className="block text-xs font-medium text-foreground-600 mb-1.5">邮箱</label>
                      <input
                        id="contact-email"
                        type="email"
                        name="email"
                        required
                        className="w-full px-3 py-2.5 text-sm rounded-lg bg-background-50 border border-background-300/60 text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400/30"
                        placeholder="请输入您的邮箱"
                      />
                    </div>
                  </div>
                  <div>
                    <label htmlFor="contact-subject" className="block text-xs font-medium text-foreground-600 mb-1.5">主题</label>
                    <input
                      id="contact-subject"
                      type="text"
                      name="subject"
                      required
                      className="w-full px-3 py-2.5 text-sm rounded-lg bg-background-50 border border-background-300/60 text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400/30"
                      placeholder="请输入消息主题"
                    />
                  </div>
                  <div>
                    <label htmlFor="contact-message" className="block text-xs font-medium text-foreground-600 mb-1.5">消息内容</label>
                    <textarea
                      id="contact-message"
                      name="message"
                      required
                      rows={5}
                      maxLength={500}
                      className="w-full px-3 py-2.5 text-sm rounded-lg bg-background-50 border border-background-300/60 text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400/30 resize-none"
                      placeholder="请输入您的消息（最多500字）"
                    ></textarea>
                    <p className="text-xs text-foreground-400 mt-1">最多500个字符</p>
                  </div>
                  {/* Honeypot */}
                  <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
                  <button
                    type="submit"
                    className="w-full px-6 py-3 bg-primary-500 text-white font-semibold text-sm rounded-full hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                  >
                    发送消息
                  </button>
                  <p id="form-msg" className="text-sm text-center mt-2"></p>
                </form>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}